import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { isCurrentMemberTeamLeader } from 'common/selectors/auth';
import DashboardMain from './DashboardMain';

const DashboardRedirect = () => {
  const isTeamLeader = useSelector(isCurrentMemberTeamLeader);

  if (isTeamLeader) {
    return <Navigate to="/app/culture-hub/analytics" replace />;
  }

  return <DashboardMain />;
};

export default DashboardRedirect;
